import React from 'react';
import { useCountdown, CountdownDisplay } from './Countdown';
import LockIcon from '@mui/icons-material/Lock';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
export function FinalCTA() {
  const timeLeft = useCountdown();
  return <section className="py-10 px-4 bg-brand-800 text-white relative overflow-hidden" data-id="element-85">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-86">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-87"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-brand-900 to-transparent" data-id="element-88"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-89">
        <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-1.5 rounded-full font-bold text-xs sm:text-sm mb-3 shadow-lg animate-pulse" data-id="element-90">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </div>

        <div className="flex justify-center mb-5 scale-110" data-id="element-91">
          <CountdownDisplay {...timeLeft} data-id="element-92" />
        </div>

        <div className="bg-white text-slate-900 rounded-2xl p-5 md:p-7 shadow-2xl border-4 border-brand-400" data-id="element-93">
          <h2 className="text-2xl font-extrabold text-brand-800 mb-1" data-id="element-94">
            🐾 PATITAS EMPRENDEDORAS™
          </h2>
          <p className="text-base font-bold text-slate-700 mb-4" data-id="element-95">
            📘 Tomo 1 + Tomo 2 + 🎁 4 Bonos
          </p>

          <div className="flex flex-col items-center justify-center mb-4" data-id="element-96">
            <span className="text-slate-400 line-through text-xl font-bold" data-id="element-97">
              $49.999
            </span>
            <div className="flex items-start text-brand-700" data-id="element-98">
              <span className="text-2xl font-bold mt-2" data-id="element-99">$</span>
              <span className="text-5xl font-extrabold tracking-tight" data-id="element-100">
                19.999
              </span>
              <span className="text-lg font-bold mt-2 ml-1" data-id="element-101">ARS</span>
            </div>
          </div>

          <button className="w-full bg-brand-600 hover:bg-brand-700 text-white text-lg md:text-xl font-bold py-4 px-6 rounded-xl shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 mb-3" data-id="element-102">
            ➜ QUIERO EMPEZAR MI NEGOCIO HOY
          </button>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs text-slate-600 font-medium" data-id="element-103">
            <div className="flex flex-col items-center gap-1" data-id="element-104">
              <LockIcon fontSize="small" className="text-slate-400" data-id="element-105" /> Pago
              seguro
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-106">
              <FlashOnIcon fontSize="small" className="text-slate-400" data-id="element-107" /> Acceso
              inmediato
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-108">
              <VerifiedUserIcon fontSize="small" className="text-slate-400" data-id="element-109" />{' '}
              Garantía 7 días
            </div>
            <div className="flex flex-col items-center gap-1 text-brand-600 font-bold" data-id="element-110">
              <LocalOfferIcon fontSize="small" data-id="element-111" /> Cupos limitados
            </div>
          </div>
        </div>
      </div>
    </section>;
}